// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2MUkB","large":"styles_large__1WV6N"};